import { Component } from '@angular/core';
import { InlineToastService } from './inline-toast.service';

@Component({
    selector: 'lib-inline-toast',
    templateUrl: './inline-toast.component.html',
    styleUrls: ['./inline-toast.component.scss'],
})
export class InlineToastComponent {
    constructor(public toast: InlineToastService) {}
}